import { formatNumToStandardNotation } from '@modules/common/utils';
import { useQuantifyStore } from '@modules/quantify/store/quantifyStore';
import { CompareReportDataPoint } from '@modules/quantify/store/types';
import { Stack, Typography } from '@mui/material';
import { EQLFunctionName } from 'v2/core/repository/eql/types';

interface CompareChartTooltipDeltaProps {
  payload: CompareReportDataPoint | null;
}

export const CompareChartTooltipDelta = ({
  payload,
}: CompareChartTooltipDeltaProps) => {
  const formulaID = useQuantifyStore(
    ({ query }) => query.formulaQuery?.eqlFunction,
  );

  const valueSuffix =
    formulaID === EQLFunctionName.NormaliseByPercent ? '%' : '';

  const getValueColor = () => {
    if (payload?.absoluteDelta === 0) {
      return 'text.secondary';
    }
    return (payload?.absoluteDelta || 0) < 0 ? 'error.light' : 'success.light';
  };

  return (
    <Stack px={1.5}>
      <Stack direction="row" alignItems="center" spacing={1}>
        <Typography variant="body2">Difference:</Typography>
        <Typography
          sx={{ color: getValueColor() }}
          variant="body2"
          fontWeight={500}
        >
          {formatNumToStandardNotation(payload?.absoluteDelta ?? 0)}
          {valueSuffix}
        </Typography>
      </Stack>
    </Stack>
  );
};
